import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faSquare } from "@fortawesome/free-solid-svg-icons/faSquare";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons/faSquareCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ModalidadesEntrega, PontosRetirada } from "app/api/classes/OrcamentoApi";
import { CodigoTipoEntrega } from "app/types/CodigoTipoEntrega";
import { CodigoTurnoEntrega } from "app/types/CodigoTurnoEntrega";
import { DataFormatoEN } from "app/types/DataFormatoEN";
import { IFilial } from "app/types/IFilial";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import clsx from "clsx";
import { useFormik } from "formik";
import globalMU from "globalMU";
import * as R from 'ramda';
import React, { useEffect } from "react";
import { InputData } from "../inputs/InputData";
import { InputNumerico } from "../inputs/InputNumerico";
import { TooltipMU } from "../tooltip/TooltipMU";
import { InputDataCalendario } from "../inputs/InputDataCalendario";
import { date } from "yup";
import { tipoOrcamentoSuportaMostruario } from "app/use-cases/orcamento/tipoOrcamentoSuportaMostruario";
const estiloEditarItens = require("./editar-item.module.scss").default;
const estiloFormulario = require('../../estilos/formulario.module.scss').default
const estiloBotoes = require('../../estilos/botoes.module.scss').default

export type Faturamento = {
  identificador: number;
  identificadorOrcamento: string;
  tipoFaturamento: string;
  descricao: string;
};

export type FilialTransferencia = {
  codigoFilialTransferencia: string;
  identificador: number;
  identificadorOrcamento: string;
  descricao: string;
};

export type FilialRetirada = {
  codigoFilialRetirada: string;
  identificador: number;
  identificadorOrcamento: string;
  descricao: string;
};

export type TurnoEntrega = {
  identificador: number;
  identificadorOrcamento: string;
  turnoEntrega: string;
  descricao: string;
};

export type TipoEntrega = {
  Codigo: string;
  Descricao: string;
};

export type ListaTiposFaturamento = {
  Description: string;
  Value: string;
};

export type ListaTurnoEntrega = {
  Description: string;
  Value: string;
};

export type EditarItemProps = {
  item: IItemOrcamento;
  exibirBotaoSimularDesconto: boolean
  exibirInputPreco: boolean
  exibirCheckBoxPreservarDesconto: boolean
  exibirCampoMarkup: boolean // 449240
  numeroCasasDecimaisPreco: number
  exibirTipoEntrega: boolean
  bloquearFaturamentoDiretoClienteRetiradaOutroLocal?: boolean // 469010
  dataMaximaParaPrevisaoEntrega?: { year: number, month: number, day: number }
  tiposEntrega: TipoEntrega[];
  listaTurnoEntrega: ListaTurnoEntrega[];
  filiaisRetirada: IFilial[];
  filiaisTransferencia: IFilial[];
  listaTiposFaturamento: ListaTiposFaturamento[];
  permitirEditarDescricao: boolean;
  exibirClasseEFornecedor: boolean
  descricaoTipoOrcamento: string;
  tipoOrcamento: number;
  definirPrevisaoEntregaPorItem: boolean;
  valorTratarVendasSobEncomenda: "0" | "1" | "2" | "3" | "4"
  vendaComEntregaPosteriorPorItem: boolean;
  apuraStOrcamento: boolean;
  apuraIpiVenda: boolean;
  bloquearEdicaoValorIpiOrcamento: boolean;
  permiteDesativarRegimeEspecialItemPedido: boolean;
  utilizaEmissaoAutomaticaNFVendaAposTransferencia: boolean;
  mostrarLocalRetirada: boolean;
  valorDespesasInclusas: boolean;
  tratamentoDiferenciadoDatasMarcadasEPrevistas: boolean;
  bloquearDescontoUnitarioOrcamento: boolean;
  desativarEdicaoOrdemPedidoCompra: boolean;
  listaModalidadesEntrega: ModalidadesEntrega[],
  listaPontosRetirada: PontosRetirada[],
  utilizaModalidadeEntregaOrcamento: boolean,
  ofertaSeletivaAtivada: boolean
  ofertaSeletivaVisivel: boolean
  despesasInclusasVisivel: boolean
  despesasInclusasAtivada: boolean
  exibirAlertaEstoqueIndisponivel: boolean
  utilizaServicoAgregadoNoOrcamento: boolean
  vendaPorRepresentacao?: boolean // 456252
  desabilitarTipoEntrega?: boolean // 474918
  somenteLeitura: boolean
  motivosDesconto: {
    Codigo?: number
    Motivo?: string
  }[]
  desativarEdicaoRegimeEspecial: boolean
  utilizaRecursoEncomendaExpressa: boolean
  desativarSelecaoPontoRetirada: boolean
  onDescricaoModificado: (descricao: string, identificadorItem: number) => void;
  onQuantidadeModificado: (
    identificadorItem: number,
    quantidade: number
  ) => void;
  onPercentualMarkUpModificado: ( identificadorItem: number, percentualMarkup: number ) => void; // 449240

  onPrecoModificado: (
    identificadorItem: number,
    preco: number,
    percentualDesconto: number,
    percentualBonificacao: number
  ) => void;
  onTipodeEntregaModificado: (
    codigoTipoEntrega: CodigoTipoEntrega
  ) => void;
  onDataPrevistaModificado: (
    dataPrevisaoEntrega: DataFormatoEN
  ) => void;
  onDataMarcadaModificado: (
    dataMarcadaEntrega: DataFormatoEN
  ) => void;
  onTurnoModificado: (turnoEntrega: CodigoTurnoEntrega) => void;
  onFilialdeRetiradaModificado: (
    codigoFilialRetirada: string
  ) => void;
  onFilialDeTransferenciaModificado: (
    codigoFilialTransferencia: string
  ) => void;
  onFaturamentoModificado: (
    tipoFaturamento: string
  ) => void;
  onPedidoDeCompraModificado: (
    identificadorItem: number,
    pedidoDeCompra: string
  ) => void;
  onLinhaDeCompraModificado: (
    identificadorItem: number,
    pedidoDeCompra: string
  ) => void;

  onAliquotaModificado: (aliquota: number, identificadorItem: number) => void;
  onValorIPIModificado: (identificadorItem: number, valor: number) => void;

  onClickSimularDesconto: () => void;
  onReplicarDataMarcadaEmTodosOsItens: () => void;
  onEntregaPosteriorModificado: (
    identificadorItem: number,
    entregaPosterior: boolean
  ) => void;
  onVendaSobEncomendaModificado: (
    vendaSobEncomenda: boolean,
    identificadorItem: number
  ) => void;
  onEncomendaExpressaModificada: (encomendaExpressa: boolean, identificadorItem: number) => void // 433263
  onPrioridadeDeMontagemModificado: (identificadorItem: number, prioridadeDeMontagem: boolean) => void // 456839
  onMostruarioModificado: (identificadorItem: number, mostruario: boolean) => void // PA 487087
  onOfertasSeletivasModificado: (
    identificadorItem: number,
    ofertaSelecionada: boolean
  ) => void;
  onDespesasInclusasModificado: (ativado: boolean) => void;
  onRegimeEspecialModificado: (
    identificadorItem: number,
    desativaRegimeEspecial: boolean
  ) => void;
  onOidModalidadeEntregaModificado: (
    oidModalidadeEntrega: number
  ) => void;
  onIdPontoRetiradaModificado: (idPontoRetirada: number) => void;
  onProdutoSemEstoqueDisponivel: (item: IItemOrcamento) => void
  onAlterarPrecoTinta: () => void
  onMotivoDescontoAlterado: (codigoMotivoDesconto: number) => void
  onServicosAgregadosModificado: () => void;
}



export const EditarItem = (props: EditarItemProps) => {

  const obterDadosEditarItemProps = (): IItemOrcamento => ({
    ...props.item,
  });

  const formik = useFormik<IItemOrcamento>({
    initialValues: obterDadosEditarItemProps(),
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });


  useEffect(() => {
    // Não há necessidade de fazer um `setValues` na montagem inicial, pois o Formik já é inicializado com os valores corretos.
	formik.setValues({
      ...formik.values,
      ...obterDadosEditarItemProps(),
    });


  }, [props.item]);

  const codigo = <>
    <label>Código</label>
    <input
      disabled

      name="Codigo"
      id="EditarItem_EditarItem_Codigo"
      maxLength={5}
      value={(formik.values?.Codigo) ?? ""}
      className="_w-28"

    />
  </>

  const descricao = <>
    <label>Descrição</label>
    <input
      disabled={props.somenteLeitura || !props.permitirEditarDescricao}
      className="_w-[400px]"
      name="DescricaoProduto"
      id="EditarItem_DescricaoProduto"
      title="Veja parâmetros:
            -Permite incluir descrição temporária para o produto no orçamento
            -Utilizar descrição longa de produtos por filial
            -Tamanho da descrição longa de produtos (caracteres) por filial
            -Utilizar descrição longa de produtos
            -Tamanho da descrição longa de produtos (caracteres)"
      value={(formik.values?.DescricaoProduto) ?? ""}
      onChange={formik.handleChange}
      onBlur={(e) =>
        props.onDescricaoModificado(
          e.target.value,
          formik.values.Identificador
        )
      }
    />
  </>

  const referencia = <>
    <label>Referência</label>
    <input
      disabled

      name="ReferenciaProduto"
      id="EditarItem_ReferenciaProduto"
      maxLength={30}
      value={(formik.values?.ReferenciaProduto) ?? ""}
      className="_w-64"

    />
  </>

  const classe = <>
    <label>Classe</label>
    <input
      disabled
      value={`${formik.values?.CodigoClasse} - ${formik.values?.ClasseProduto}`}
      className="_w-[400px]"
      name="ClasseProduto"
      id="EditarItem_ClasseProduto"
      maxLength={30}
      onChange={formik.handleChange}
    />
  </>

  const fornecedor = <>
    <label>Fornecedor</label>
    <input
      disabled
      className="_w-[400px]"
      name="Fornecedor"
      id="EditarItem_Fornecedor"
      maxLength={30}
      value={(formik.values?.Fornecedor) ?? ""}
      onChange={formik.handleChange}
    />
  </>

  const quantidade = <>
    <label><u>Q</u>uantidade</label>
    <div>
      <InputNumerico
        onValorModificado={(valor) => {
          formik.setFieldValue("Quantidade", valor);
          props.onQuantidadeModificado(formik.values.Identificador, valor);
        }}
        teclaDeAtalho="q"
        numeroCasasDecimais={3}
        selecionaValorOnFocus={true}
        campoNullavel={true}
        id="EditarItem_Quantidade"
        valor={formik.values?.Quantidade || 0}
        classesInput={["_w-64"]}
        //disabled={props.somenteLeitura}
        disabled={props.somenteLeitura || formik.values.EtiquetaPesagem || (formik.values.Madeira == true) || (formik.values.Classe.toLowerCase() == "itempedidovendasubordinado")} // 461135
        title={(formik.values?.Madeira == true) 
          ? "Desabilitado por ser produto com tratamento madeira" 
          : formik.values?.EtiquetaPesagem 
                  ? "Entrada do produto realizada através da leitura de etiqueta. Quantidade do produto não pode ser alterada." 
                  : undefined
      }
        autoFocus
      />

      {props.exibirAlertaEstoqueIndisponivel && (
        <TooltipMU title="Quantidade indisponível">
          <div style={{
            display: "inline"
          }}>
            <FontAwesomeIcon
              onClick={() => props.onProdutoSemEstoqueDisponivel(formik.values)}
              cursor={"pointer"}
              icon={faExclamationTriangle}
              color="#ff0000"
              fontSize={"18px"}
              style={{ marginTop: "3px", marginLeft: "5px" }}
            />
          </div>
        </TooltipMU>
      )}
    </div>

  </>

const campoPercentualMarkup = <>
<label
  title="Veja parâmetros:&#013;-Custo utilizado no Cálculo do Mark-Up&#013;-Visualiza Mark-up do produto no orçamento?"
>% Markup</label>
<div>
  <InputNumerico
    onValorModificado={(valor) => {
      formik.setFieldValue("PercentualMarkUp", valor);
      props.onPercentualMarkUpModificado(formik.values.Identificador, valor);
    }}
    numeroCasasDecimais={2} //{props.numeroCasasDecimaisPreco}
    selecionaValorOnFocus={true}
    campoNullavel={true}
    id="EditarItem_PercentualMarkUp"
    valor={formik.values?.PercentualMarkUp || 0}
    classesInput={["_w-64"]}
    disabled={props.somenteLeitura}
  />
</div>
</> // 449240

  const preco = () => {

    const label = <label><u>P</u>reço</label>

    const corInputPreco: "green" | "red" | undefined =
      !formik.values.DescontoPendente && formik.values.PrecoAlteradoManualmente && !formik.values.PendenciaDescontoSobreOferta ? "green" :
        formik.values.DescontoPendente || formik.values.PendenciaDescontoSobreOferta ? "red" :
          undefined

    const inputPreco = <InputNumerico
      style={{ color: corInputPreco }}
      onValorModificado={(valor) => {
        formik.setFieldValue("PrecoProduto", valor);
        props.onPrecoModificado(
          formik.values.Identificador,
          valor,
          formik.values.PercentualDesconto,
          formik.values.PercentualBonificacao
        );
      }}
      title="Veja parâmetros: &#013;-Número de casas decimais no Preço de Venda&#013;-Altera preço de venda no Orçamento"
      numeroCasasDecimais={props.numeroCasasDecimaisPreco}
      selecionaValorOnFocus={true}
      campoNullavel={true}
      teclaDeAtalho="p"
      id="EditarItem_PrecoProduto"
      valor={formik.values?.PrecoProduto || 0}
      disabled={props.somenteLeitura || !formik.values.PermiteAlterarPreco}
      classesInput={["_w-64"]}
    />

    const labelPreco = <span>
      {globalMU.formatarValorNumerico(props.item.PrecoProduto, props.numeroCasasDecimaisPreco, true)}
    </span>

    const botaoSimularDesconto = <button
      type="button"
      accessKey="S"
      title="Veja parâmetros: &#013;-Bloqueia desconto unitário no orçamento.&#013;-Altera preço de venda no Orçamento"
      id="EditarItem_BotaoSimularDesconto"
      onClick={() => props.onClickSimularDesconto()}
      className={estiloEditarItens.botao}>
      <u>S</u>imular Desconto
    </button>

    return <>

      {label}

      <div>
        {props.exibirInputPreco ? inputPreco : labelPreco}

        {props.exibirBotaoSimularDesconto && botaoSimularDesconto}

      </div>
    </>
  }

  const precoTinta = <>
    <label>Preço Tinta</label>
    <div>
      <span>
        {globalMU.formatarValorNumerico(props.item.PrecoTinta, 2, false)}
      </span>
      <button
        onClick={() => props.onAlterarPrecoTinta()}
        type="button"
        className={estiloEditarItens.botao}
      >
        Alterar preço
      </button>
    </div>
  </>

  const preservarDesconto = <>
    <label htmlFor="EditarItem_PreservaDesconto" style={{ cursor: 'pointer' }}>Preservar Desconto</label>
    <input
      type="checkbox"
      name="PreservaDesconto"
      id="EditarItem_PreservaDesconto"
      checked={formik.values.PreservaDesconto ?? false}
      disabled={props.somenteLeitura || formik.values.ValorDesconto == 0}
    />
  </>

  const prioridadeDeMontagem = <> 
 <label 
  htmlFor="EditarItem_PrioridadeDeMontagemCheckbox" 
  id="EditarItem_PrioridadeDeMontagemCheckboxLabel" 	
  title="Veja parâmetro: Trabalha com ordem de carga e ordem de entrega na montagem de carga / Faturamento?"
  style={{ cursor: 'pointer' }}
  >
  Prioridade de Montagem
  </label>
    <input
      disabled={props.somenteLeitura}
      type="checkbox"
      id="EditarItem_PrioridadeDeMontagemCheckbox"
      onChange={(e) => {
        formik.handleChange(e)
        props.onPrioridadeDeMontagemModificado( 
          formik.values.Identificador,
          e.target.checked
        )
      }}
      checked={formik.values.PrioridadeMontagem ?? false}
    />
  </>

  const mostruario = <>
    <label
      htmlFor="EditarItem_Mostruario"
      id="EditarItem_MostruarioLabel"
      style={{ cursor: 'pointer' }}
    >
      Mostruário
    </label>
    <input
      disabled={props.somenteLeitura}
      type="checkbox"
      name="Mostruario"
      id="EditarItem_Mostruario"
      onChange={(e) => {
        formik.handleChange(e)
        props.onMostruarioModificado(
          formik.values.Identificador,
          e.target.checked
        )
      }}
      checked={formik.values.Mostruario ?? false}
    />
  </>

  const ofertaSeletiva = <>
    <label htmlFor="EditarItem_OfertaSelecionada" style={{ cursor: 'pointer' }}>Oferta Seletiva</label>
    <input
      disabled={props.somenteLeitura || !props.ofertaSeletivaAtivada}
      type="checkbox"
      name="OfertaSelecionada"
      id="EditarItem_OfertaSelecionada"
      onChange={(e) => {
        formik.handleChange(e)
        props.onOfertasSeletivasModificado(
          formik.values.Identificador,
          e.target.checked
        )
      }}
      checked={formik.values.OfertaSelecionada > 0}
    />
  </>

  const despesasInclusas = <>
    <label htmlFor="EditarItem_DespesasInclusas" style={{ cursor: 'pointer' }}>Despesas Inclusas</label>
    <input
      disabled={props.somenteLeitura || !props.despesasInclusasAtivada}
      type="checkbox"
      name="DespesasInclusas"
      id="EditarItem_DespesasInclusas"
      checked={props.item.DespesasInclusas ?? false}
      onChange={(e) => props.onDespesasInclusasModificado(e.target.checked)}
    />
  </>

  const tipoEntrega = <>
    <label
      title="Veja parâmetro: Manter filial de retirada ao trocar tipo de entrega de Futura para Expedição?"
    >Tipo de Entrega</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect, "_w-64")}
      value={formik.values.CodigoTipoEntrega ?? ""}
      name="CodigoTipoEntrega"
      id="EditarItem_CodigoTipoEntrega"
      disabled={props.somenteLeitura 
            || props.vendaPorRepresentacao 
            || props.desabilitarTipoEntrega // 474918
          }
      onChange={e => {
        formik.handleChange(e)
        props.onTipodeEntregaModificado(e.target.value as CodigoTipoEntrega)
      }}

    >
      {props.tiposEntrega?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Descricao}
        </option>
      ))}
    </select>
  </>

  const dataPrevista = <>
    <label>Data Prevista</label>
    <InputDataCalendario
                disabled={props.somenteLeitura || formik.values.BloquearEdicaoDataPrevisaoEntrega }
                className='_w-full'
                id="EditarItem_DataPrevista"
                key="EditarItem_DataPrevista"
                // dataMinima={{ year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }}
                // dataMaxima={{ year: 2026, month:5, day: 10 }}
                bloquearDataMenorQueHoje={true}
                dataMaxima={props.dataMaximaParaPrevisaoEntrega} // 449240
                data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataPrevisaoEntrega)}
                onChange={e => {(formik.setFieldValue("DataPrevisaoEntrega",e), props.onDataPrevistaModificado(e))}}
                selecionaValorOnFocus
            />
  </>

  const dataMarcada = <>
  
    <label>Data Marcada</label>
    <div className="_flex _flex-row _gap-2" style={{maxHeight: "26px"}}>
      <InputData
        id="EditarItem_DataMarcada"
        key="EditarItem_DataMarcada"
        className="_w-full"
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataMarcadaEntrega)}
        onChange={e => {(formik.setFieldValue("DataMarcadaEntrega", e), props.onDataMarcadaModificado(e))}}
        bloquearDataMenorQueHoje={true}
        selecionaValorOnFocus
        disabled={props.somenteLeitura || formik.values.BloquearEdicaoDataMarcadaEntrega} 
        
      />

      {!props.tratamentoDiferenciadoDatasMarcadasEPrevistas && !formik.values.BloquearEdicaoDataMarcadaEntrega && (
        <button
          id="EditarItem_BtnReplicarDatas"
          key="EditarItem_BtnReplicarDatas"
          disabled={props.somenteLeitura || formik.values.BloquearEdicaoDataMarcadaEntrega || !globalMU.dataHoraFormatoENComTEhValida(formik.values.DataMarcadaEntrega)}
          className={clsx('no-global-button _whitespace-nowrap', estiloBotoes.botaoPrimario)}
          onClick={() => props.onReplicarDataMarcadaEmTodosOsItens()}
        >
          Replicar data nos demais itens
        </button>
      )}
    </div>
  </>

  const turno = <>
    <label>Turno</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      name="TurnoEntrega"
      id="EditarItem_TurnoEntrega"
      value={formik.values?.TurnoEntrega ?? ""}
      disabled={props.somenteLeitura}
      onChange={e => {


        if (globalMU.isNullOrEmpty(e.target.value) || Number(e.target.value) != formik.values.TurnoEntrega) {
          props.onTurnoModificado(globalMU.isNullOrEmpty(e.target.value) ? null : Number(e.target.value) as CodigoTurnoEntrega)
        }

        formik.handleChange(e)

      }}

    >
      <option value=""></option>
      {props.listaTurnoEntrega?.map((value) => (
        <option key={value.Value} value={value.Value}>
          {value.Description}
        </option>
      ))}
    </select>
  </>

  const vendaSobEncomenda = <>
    <label htmlFor="EditarItem_VendaSobEncomenda" style={{ cursor: 'pointer' }}
      title="Veja parâmetro: Tratar vendas sob encomenda"
    >Venda Sob Encomenda</label>
<input
      disabled={ props.somenteLeitura ||
        /*
        props.valorTratarVendasSobEncomenda == "1" ||
        props.valorTratarVendasSobEncomenda == "2"
        */
        props.valorTratarVendasSobEncomenda == "1"  
            // 490854 || ( props.item.VendaSobEncomenda && props.item.EncomendaAutomatica ) // 444764
            || ( props.valorTratarVendasSobEncomenda !== "2" && props.item.VendaSobEncomenda && props.item.EncomendaAutomatica ) // 444764/490854
            || props.vendaPorRepresentacao // 456252
      }
      type="checkbox"
      name="VendaSobEncomenda"
      id="EditarItem_VendaSobEncomenda"
      title="Veja parâmetro: &#0013;-Tratar vendas sob encomenda&#0013;-Bloqueia a seleção automática da entrega posterior no orçamento  para item sob encomenda&#0013;-Solicitar senha de liberação para Vendas Sob Encomenda?"
      onChange={(e) => {
        formik.handleChange(e);
        props.onVendaSobEncomendaModificado(
          e.target.checked,
          formik.values.Identificador
        );
      }}
      checked={formik.values.VendaSobEncomenda ?? false}
    />
  </>

const servicosAgregados = <>
<label htmlFor="EditarItem_ServicoAgregado" style={{ cursor: 'pointer' }}>Servicos Agregados</label>
<input
  disabled={ props.somenteLeitura || 
    props.valorTratarVendasSobEncomenda == "1" ||
    props.valorTratarVendasSobEncomenda == "2"
  }
  type="checkbox"
  name="ServicoAgregado"
  id="EditarItem_ServicoAgregado"
  onChange={(e) => {
    formik.handleChange(e);
    props.onServicosAgregadosModificado();
  }}
  checked={props.item.ServicoAgregado ?? false}
/>
</>

const encomendaExpressa = <>
<label htmlFor="EditarItem_EncomendaExpressa" style={{ cursor: 'pointer' }}>Encomenda Expressa</label> 
<input
  disabled={ props.somenteLeitura || !formik.values.VendaSobEncomenda } // so pode marcar encomenda expressa se tiver como "encomandar" PA 433263
  type="checkbox"
  id="EditarItem_EncomendaExpressa"
  onChange={(e) => {
    formik.handleChange(e);
    props.onEncomendaExpressaModificada( e.target.checked, formik.values.Identificador);
  }}
  checked={formik.values.EncomendaExpressa ?? false}
/>
</>

  const entregaPosterior = <>
    <label htmlFor="EditarItem_EntregaPosterior" style={{ cursor: 'pointer' }}>Entrega Posterior</label>
    <input
      type="checkbox"
      name="EntregaPosterior"
      id="EditarItem_EntregaPosterior"
      checked={formik.values?.EntregaPosterior ?? false}
      disabled={props.somenteLeitura}
      onChange={(e) => {
        if (formik.values.VendaSobEncomenda && formik.values.EntregaPosterior) return
        formik.handleChange(e);
        props.onEntregaPosteriorModificado(
          formik.values.Identificador,
          e.target.checked
        );
        
      }}
    />
  </>

  const filialRetirada = <>
    <label>Filial de Retirada</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      name="CodigoFilialRetirada"
      id="EditarItem_CodigoFilialRetirada"
      value={formik.values?.CodigoFilialRetirada ?? ""}
      disabled={props.somenteLeitura || props.vendaPorRepresentacao}
      onChange={e => {
        formik.handleChange(e)
        props.onFilialdeRetiradaModificado(e.target.value)

      }}

    >
      <option value=""></option>
      {props.filiaisRetirada?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Descricao}
        </option>
      ))}
    </select>
  </>

  const filialTransferencia = <>
    <label>Filial de Transferência</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      name="CodigoFilialTransferencia"
      id="EditarItem_CodigoFilialTransferencia"
      value={formik.values?.CodigoFilialTransferencia ?? ""}
      disabled={props.somenteLeitura  
        || props.vendaPorRepresentacao 
        || props.item.BloquearAlteracaoLocalRetirada
        || props.item.DesativarEdicaoFilialTransferencia
      }
      onChange={e => {
        formik.handleChange(e)
        props.onFilialDeTransferenciaModificado(e.target.value)
      }}

    >
      <option value=""></option>
      {props.filiaisTransferencia?.map((value) => (
        <option key={value.Codigo} value={value.Codigo}>
          {value.Descricao}
        </option>
      ))}
    </select>
  </>

  const faturamento = <>
    <label>Faturamento</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      disabled={props.somenteLeitura 
          || props.item.DesativarEdicaoTipoFaturamento // 466376
          || props.bloquearFaturamentoDiretoClienteRetiradaOutroLocal // 469010
          || !formik.values.CodigoFilialRetirada || props.item.BloquearAlteracaoLocalRetirada}
      name="TipoFaturamento"
      id="EditarItem_TipoFaturamento"
      value={formik.values?.TipoFaturamento ?? ""}
      onChange={e => {
        formik.handleChange(e)
        props.onFaturamentoModificado(e.target.value)
      }}

    >
      <option value=""></option>
      {props.listaTiposFaturamento?.map((value) => (
        <option key={value.Value} value={value.Value}>
          {value.Description}
        </option>
      ))}
    </select>
  </>

  const regimeEspecial = <>
    <label htmlFor="EditarItem_DesativaRegimeEspecial" style={{ cursor: 'pointer' }}>Regime Especial</label>
    <input
      disabled={props.somenteLeitura || props.desativarEdicaoRegimeEspecial}
      type="checkbox"
      name="DesativaRegimeEspecial"
      id="EditarItem_DesativaRegimeEspecial"
      onChange={(e) => {
        formik.handleChange(e);
        props.onRegimeEspecialModificado(
          formik.values.Identificador,
          e.target.checked
        );
      }}
      checked={formik.values.DesativaRegimeEspecial ?? false}
    />
  </>

  const valorSubstituicao = <>
    <label>Valor Substituição</label>
    <InputNumerico
      numeroCasasDecimais={2}
      campoNullavel={true}
      id="EditarItem_ValorSubstituicao"
      valor={formik.values?.ValorSubstituicao ?? 0}
      disabled
      classesInput={["_w-64"]}
    />
  </>

  const modalidadeEntrega = <>
    <label>Modalidade de Entrega</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      name="OidModalidadeEntrega"
      id="EditarItem_OidModalidadeEntrega"
      value={formik.values?.OidModalidadeEntrega ?? ""}
      onChange={e => {
        formik.handleChange(e)
        props.onOidModalidadeEntregaModificado(globalMU.isNullOrEmpty(e.target.value) ? 0 : Number(e.target.value))
      }}

    >
      <option value=""></option>
      {props?.listaModalidadesEntrega?.map((value) => (
        <option key={value?.Codigo} value={value?.Codigo}>
          {value?.Nome}
        </option>
      ))}
    </select>
  </>

  const pontoRetirada = <>
    <label>Ponto de Retirada</label>
    <select
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      disabled={props.somenteLeitura || props.desativarSelecaoPontoRetirada}
      name="IdPontoRetirada"
      id="EditarItem_IdPontoRetirada"
      value={formik.values?.IdPontoRetirada ?? ""}
      onChange={e => {
        formik.handleChange(e)
        props.onIdPontoRetiradaModificado(globalMU.isNullOrEmpty(e.target.value) ? 0 : Number(e.target.value))
      }}

    >
      <option value=""></option>
      {props?.listaPontosRetirada?.map((value) => (
        <option key={value?.Id} value={value?.Id}>
          {value?.Nome}
        </option>
      ))}
    </select>
  </>

  const aliquotaIPI = <>
    <label>Alíquota IPI (%)</label>
    <InputNumerico
      classesInput={["_w-64"]}
      onValorModificado={(valor) => {
        formik.setFieldValue("AliquotaIPI", valor);
        props.onAliquotaModificado(
          valor,
          formik.values.Identificador
        );
      }}
      numeroCasasDecimais={2}
      selecionaValorOnFocus={true}
      campoNullavel={true}
      id="EditarItem_AliquotaIPI"
      valor={formik.values?.AliquotaIPI || 0}
      disabled={props.somenteLeitura || props.bloquearEdicaoValorIpiOrcamento}
    />
  </>

  const valorIPI = <>
    <label>Valor IPI</label>
    <InputNumerico
      classesInput={["_w-64"]}
      onValorModificado={(valor) => {
        formik.setFieldValue("ValorIPI", valor);
        props.onAliquotaModificado(
          valor,
          formik.values.Identificador
        );
      }}
      numeroCasasDecimais={2}
      selecionaValorOnFocus={true}
      campoNullavel={true}
      id="EditarItem_ValorIPI"
      valor={formik.values?.ValorIPI || 0}
      disabled
    />
  </>

  const pedidoCompra = <>
    <label>Pedido de Compra</label>
    <input
      className="_w-64"
      style={{maxHeight: "26px"}}
      name="PedidoCompra"
      id="EditarItem_PedidoCompra"
      value={(formik.values?.PedidoCompra) ?? ""}
      onChange={formik.handleChange}
      disabled={props.somenteLeitura}
      onBlur={(e) =>
        props.onPedidoDeCompraModificado(
          formik.values.Identificador,
          e.target.value
        )
      }
    />
  </>

  const linhaDaOrdemDeCompra = <>
    <label>Linha da Ordem de Compra</label>
    <input
      disabled={props.desativarEdicaoOrdemPedidoCompra}
      style={{maxHeight: "26px"}}
      className="_w-64"
      name="PedidoCompraCliente"
      id="EditarItem_PedidoCompraCliente"
      title="Somente ficará habilitado se CLIENTE for selecionado e parâmetro [Permite informar a linha do pedido de compra no orçamento] ativado"
      value={(formik.values?.PedidoCompraCliente) ?? ""}
      onChange={formik.handleChange}
      onBlur={(e) =>
        props.onLinhaDeCompraModificado(
          formik.values.Identificador,
          e.target.value
        )
      }
    />
  </>

  const motivoDesconto = <>
    <label>Motivo do Desconto</label>
    <select
      disabled={props.somenteLeitura}
      className={clsx(estiloFormulario.ignoreSelect,"_w-64")}
      value={props.item.CodigoMotivoDesconto ?? ""}
      onChange={e => props.onMotivoDescontoAlterado(Number(e.target.value))}>
      <option value="0"></option>
      {(props.motivosDesconto ?? []).map(motivo => <option key={motivo.Codigo} value={motivo.Codigo}>
        {motivo.Motivo}
      </option>)}
    </select>
  </>


  return (

    <div className={estiloFormulario.formulario}>
      {codigo}

      {descricao}

      {referencia}

      {props.exibirClasseEFornecedor && (
        <>
          {classe}

          {fornecedor}
        </>
      )}

      {quantidade}

      {preco()}

      {props.item.CodigoTinta > 0 && precoTinta}

      {props.exibirCampoMarkup && campoPercentualMarkup} 

      {props.exibirCheckBoxPreservarDesconto && preservarDesconto}

      {motivoDesconto}

      {props.ofertaSeletivaVisivel && ofertaSeletiva}

      {props.despesasInclusasVisivel && despesasInclusas}

      {props.exibirTipoEntrega && tipoEntrega}

      {props.tipoOrcamento !== 2 && props.definirPrevisaoEntregaPorItem  && formik.values.CodigoTipoEntrega != "C" && <>
        {dataPrevista}

        {dataMarcada}

        {turno}

      </>}

      {props.tipoOrcamento !== 2 && formik.values.CodigoTipoEntrega != "C" && (
        <>
          {!R.includes(props.valorTratarVendasSobEncomenda, ["0", undefined, null]) 
                && !props.vendaPorRepresentacao // 456252/468760
                && vendaSobEncomenda}
          {props.tipoOrcamento == 0 && props.utilizaRecursoEncomendaExpressa 
              && !props.vendaPorRepresentacao // 456252/468760
              && encomendaExpressa}
          {props.vendaComEntregaPosteriorPorItem && entregaPosterior}
        </>
      )}

      {props.utilizaServicoAgregadoNoOrcamento &&   servicosAgregados}

      {props.mostrarLocalRetirada &&
        !props.item.OcultarRetiradaOutroLocal &&
        props.tipoOrcamento !== 2 && formik.values.CodigoTipoEntrega != "C" && (
          <>
            {filialRetirada}

            {filialTransferencia}

            {faturamento}
          </>
        )}
      {props.permiteDesativarRegimeEspecialItemPedido && props.utilizaEmissaoAutomaticaNFVendaAposTransferencia && regimeEspecial}

      {props.apuraStOrcamento && valorSubstituicao}


      {props.tipoOrcamento == 0 && formik.values?.CodigoTipoEntrega == 'F' && props?.utilizaModalidadeEntregaOrcamento &&
        <>
          {modalidadeEntrega}

          {pontoRetirada}
        </>
      }

      {props.apuraIpiVenda && (
        <>
          {aliquotaIPI}

          {valorIPI}
        </>
      )}

      {props.tipoOrcamento === 0 && prioridadeDeMontagem}
      {tipoOrcamentoSuportaMostruario(props.tipoOrcamento) && mostruario}
      {props.tipoOrcamento !== 2 && (
        <>
          {pedidoCompra}

          {linhaDaOrdemDeCompra}
        </>
      )}
      <section style={{ marginBottom: "100px" }} />
    </div>

  );
};
